import { combine, Token, type Lexer } from '@parser';

export class LineComment extends Token<undefined> {
  static lex(lexer: Lexer): LineComment | undefined {
    return lexer.withContext('LineComment', () => {
      const match1 = lexer.stringLiteral('//');
      if (match1 === undefined) {
        return undefined;
      }
      const match2 = lexer.consumeUntilNLOrEOF();
      const match = combine([match1, match2]);
      return new LineComment(match.text, {
        start: match.start,
        end: match.end
      });
    });
  }
}

export class BlockComment extends Token<undefined> {
  static lex(lexer: Lexer): BlockComment | undefined {
    const match = lexer.consumeUntilBalanced('/*', '*/');
    if (match === undefined) {
      return undefined;
    }
    return new BlockComment(match.text, { start: match.start, end: match.end });
  }
}
